<template>
  <div class="sms-slider-wrap">
    <div ref="sliderEl"></div>
  </div>
</template>

<script>
import 'styles/slider-captcha.css'
import 'assets/js/slider-captcha.js'

export default {
  name: 'SmsSlider',
  data () {
    return {
      inst: null
    }
  },
  mounted () {
    this.$nextTick(() => this.mountSlider())
  },
  beforeDestroy () {
    this.inst = null
  },
  methods: {
    /**
     * 滑块走 member 主站 /captcha（已验证可用）
     * 不要走 /jiekou/captcha（线上该入口当前 500）
     */
    captchaBase () {
      const front = (this.$store && this.$store.state && this.$store.state.frontend_url) || ''
      return (front || 'https://member.foundry.org.cn').replace(/\/$/, '')
    },
    mountSlider () {
      try {
        if (!this.$refs.sliderEl) {
          return
        }
        if (!window.SliderCaptcha || typeof window.SliderCaptcha.mount !== 'function') {
          console.error('[SmsSlider] SliderCaptcha 未加载')
          return
        }
        if (this.inst) {
          return
        }
        const base = this.captchaBase()
        this.inst = window.SliderCaptcha.mount(this.$refs.sliderEl, {
          getUrl: base + '/captcha/get',
          checkUrl: base + '/captcha/check'
        })
      } catch (e) {
        console.error('[SmsSlider] mount failed', e)
      }
    },
    getTicket () {
      return (this.inst && this.inst.getTicket()) || ''
    },
    reset () {
      if (this.inst) {
        this.inst.reset()
      }
    }
  }
}
</script>

<style scoped>
.sms-slider-wrap {
  margin: 0.2rem 0.3rem 0.3rem;
  background: #fff;
  padding: 0.2rem;
}
.sms-slider-wrap >>> .slider-captcha {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/SmsSlider.vue